import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-404-shipment',
  templateUrl: '404-shipment.component.html',
})
export class Page404ShipmentComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
